import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import actions from 'state/actions';
import { actionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import { PoMicroCategoryList, PoVendorList } from 'models/response';

const Add = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const editedRowId = useSelector(selectors.configurator.getEditedRowId);
  const selectedTable = useSelector(selectors.configurator.selectTableToSearch);
  const selectedRow = useSelector(selectors.configurator.getSelectedRow);
  const rows = useSelector(selectors.configurator.getLeftTableRows);

  const addRow = async () => {
    dispatch(actions.configurator.setEditedRowId('-1'));
    if (selectedTable === 'vendor') {
      const row: PoVendorList = {
        id: '-1',
        companyName: '',
        subjectName: '',
        fluxName: 'PO',
        wfCausal: '',
        wfIdCausal: -1,
        wfIdWorkflowDefinition: -1,
        workflowDefinition: '',
        idAction: -1,
        idCompany: -1,
        microcategoryLatency: [],
        fullOcr: false,
        supplierCode: '',
      };
      dispatch(actions.configurator.setLeftTableRows([row, ...(rows as PoVendorList[])]));
      return;
    }
    const row: PoMicroCategoryList = {
      id: '-1',
      companyName: '',
      fluxName: 'PO',
      wfCausal: '',
      wfIdCausal: -1,
      wfIdWorkflowDefinition: -1,
      workflowDefinition: '',
      idAction: -1,
      idCompany: -1,
      fullOcr: false,
      microcategoryCode: '',
      microcategoryDescription: '',
      subjectList: [],
    };
    dispatch(actions.configurator.setLeftTableRows([row, ...(rows as PoMicroCategoryList[])]));
  };

  return (
    <CommonButton
      id="add-row-action-table"
      action={addRow}
      scope="tertiary"
      value={t('addActionTable')}
      customIcon="plus"
      disabled={
        editedRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.ACTION_TABLE_ADD_ROW, selectedRow?.companyName)
      }
    />
  );
};

export default Add;
